// Glow component. Better to use an inline SVG than add an HTTP request.
export function Glow(props: React.ComponentProps<"svg">) {
  return (
    <svg viewBox="0 0 390 420" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <radialGradient
          cx={195}
          cy={210}
          fx={195}
          fy={210}
          gradientTransform="matrix(1 0 0 .77 0 48.95)"
          gradientUnits="userSpaceOnUse"
          id="a"
          r={270.71}
        >
          <stop offset={0} stopColor="#abfc00" />
          <stop offset={0.98} stopColor="#f2f2f2" />
        </radialGradient>
      </defs>
      <path
        d="M-80 0h550v420H-80z"
        style={{
          fill: "url(#a)"
        }}
      />
    </svg>
  )
}
